import DetailPage from "../components/DetailPage";
import { detailPages } from "../data/detailPages";

export default function ScaleGovernanceInsights() {
  return <DetailPage data={detailPages["scale-governance-insights"]} />;
}
